module.exports = __webpack_public_path__ + "img/story2.10c045bf.png";